import React from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { MixedWidget2 } from '../../../_metronic/partials/widgets'
import { isMobile, isTablet, isBrowser } from 'react-device-detect'
import platform from 'platform'

const DashboardPage = () => {
  const deviceType = isMobile ? 'Mobile' : isTablet ? 'Tablet' : isBrowser ? 'Desktop' : 'Unknown Device';
  const browserName = platform.name || 'Unknown Browser';
  const osName = platform.os?.family || 'Unknown OS';
  const osVersion = platform.os?.version || 'Unknown Version';

  return (
    <>
      <div className='row g-5 g-xl-8'>
        <div className='col-xxl-4'>
          <div className='card card-xxl-stretch mb-xl-3'>
            <div className='card-body'>
              <div className="row justify-content-center">
                <h1 className='text-bold'>Dashboard</h1>
                <p className='m-0'>Device: {deviceType}, Browser: {browserName}, OS: {osName} {osVersion}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* begin::Row */}
      <div className='row gy-5 g-xl-8'>
        <div className='col-xxl-4'>
          <MixedWidget2
            className='card-xl-stretch mb-xl-8'
            chartColor='primary'
            chartHeight='200px'
            strokeColor='#1c6f9f'
          />
        </div>
      </div>
      {/* end::Row */}
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
